// 設備庫存（DEV-15）的純函式：認領貼上的多列、逐台結果的文字鍵、選取能做的動作。

export interface ClaimLine {
  serial: string;
  orderRef: string;
}

/** 認領可貼多列：每列「序號 訂單號」（空白、逗號、Tab 分隔皆可）；空列略過；同一列重複只留一次；最多 max 列。
 * 回 lines + 格式不對的列號（1 起算）。 */
export function parseClaimLines(text: string, max = 50): { lines: ClaimLine[]; bad: number[]; over: boolean } {
  const lines: ClaimLine[] = [];
  const bad: number[] = [];
  const seen = new Set<string>();
  const raw = text.split(/\r?\n/);
  raw.forEach((row, i) => {
    const s = row.trim();
    if (!s) return;
    const parts = s.split(/[\s,，]+/).filter(Boolean);
    if (parts.length !== 2 || parts[0].length > 64 || parts[1].length > 128) {
      bad.push(i + 1);
      return;
    }
    const k = parts[0] + '\u0000' + parts[1];
    if (seen.has(k)) return;
    seen.add(k);
    lines.push({ serial: parts[0], orderRef: parts[1] });
  });
  return { lines: lines.slice(0, max), bad, over: lines.length > max };
}

/** 選取的列能做什麼：指派 = 還沒加入的（未上線 / 在線未加入 / 已指派可改指派）；取消指派 = 已指派的。 */
export function selectionActions(rows: { device_ref: string; status: string }[], selected: Set<string>): { assignable: string[]; unassignable: string[] } {
  const picked = rows.filter((r) => selected.has(r.device_ref));
  return {
    assignable: picked.filter((r) => r.status !== 'joined').map((r) => r.device_ref),
    unassignable: picked.filter((r) => r.status === 'assigned').map((r) => r.device_ref),
  };
}

/**
 * 節點 console `enroll_status` 的回應（或只有 `fp=` 後面那 16 碼）→ 指紋與其他欄位（SPEC #provisioning-s3-8-org）。
 * 例：`@ok #3 state=pending url=https://device.dev.kinio.rasitek.com:9443 keypwd=1 bootkey=1 fp=a1b2c3d4e5f60718`
 * fp 不是 16 個十六進位字 → fp = ''。url / keypwd 沒貼整行時是 undefined。
 */
export function parseEnrollLine(text: string): { fp: string; url?: string; keypwd?: boolean; state?: string } {
  const s = text.trim();
  const kv = (k: string) => {
    const m = new RegExp(`(?:^|\\s)${k}=(\\S+)`).exec(s);
    return m ? m[1] : undefined;
  };
  const raw = (kv('fp') ?? (/^\S+$/.test(s) ? s : '')).toLowerCase();
  const kp = kv('keypwd');
  return { fp: /^[0-9a-f]{16}$/.test(raw) ? raw : '', url: kv('url'), keypwd: kp === undefined ? undefined : kp === '1', state: kv('state') };
}

/** 報到網址比對：去掉結尾斜線、不分大小寫（只比 scheme://host[:port]，路徑不比）。 */
export function sameEnrollOrigin(a: string, b: string): boolean {
  const norm = (u: string) => {
    try {
      const x = new URL(u);
      return `${x.protocol}//${x.host}`.toLowerCase();
    } catch {
      return u.trim().replace(/\/+$/, '').toLowerCase();
    }
  };
  return norm(a) === norm(b);
}
